var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-list"},_vm._l((_vm.companyList),function(item,index){return _c('CompanyItem',{key:index,attrs:{"company-item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }